// extracted by mini-css-extract-plugin
export default {"logo":"index_logo_xYxhE","breadcrumbs":"index_breadcrumbs_ifQz3"};